import {QuizSession} from '@cp/model';
import {useMemo} from 'react';
import subscribeQuizSessionCollectionActive from '../../api/quizSession/subscribeQuizSessionCollectionActive';
import {useFunctionSubscribe} from '../helper/function/useFunctionSubscribe';
import {useAuth} from '../users/useAuth';

const DEFAULT_LIMIT = 10;

interface UseUserActiveSessionsOptions {
  limit?: number;
  offset?: number;
}

export default function useUserActiveSessions(options?: UseUserActiveSessionsOptions) {
  const user = useAuth();
  const uid = user?.id ?? '';
  const limit = options?.limit ?? DEFAULT_LIMIT;

  const subscribe = useMemo(
    () => (onData: (data: QuizSession[]) => void, onError: (err: Error) => void) =>
      subscribeQuizSessionCollectionActive(uid, onData, onError, limit),
    [uid, limit],
  );

  const {
    data = [],
    loading,
    error,
  } = useFunctionSubscribe<QuizSession[]>(subscribe, {
    skip: !uid,
    deps: [uid, limit],
  });

  return {
    sessions: data,
    loading,
    error,
    refetch: () => Promise.resolve(),
  };
}
